import React,{useEffect,useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import tlogo from '../assets/img/logx.png';
import ArticleService from '../services/ArticleService';

const styles = {
  tactionb:{
  backgroundColor:'#098208',
  color:'transparent',
  padding:10
},
ttlebar:{
  fontSize:12,
  borderWidth:1,
  borderColor:'orange',
  paddingTop:0.5,
  paddingBottom:0.5,
  backgroundColor:'#3c10a2',
  color:'#ffffff',
  textAlign:'center',
  fontFamily:'Arial, sans-serif'
},
imgmain:{
width:'100%',
height:240,
marginBottom:-4,
objectFit:'cover'
},
palign:{
  margin:15,
  textAlign:'justify'
},
btnvermas:{
  backgroundColor:'#098208',
  textDecoration:'none',
  color:'#ffffff',
  padding:10,
  paddingLeft:90,
  paddingRight:90,
  borderRadius:10,
}
};

function DetailArticle(){

let [searchParams, setSearchParams] = useSearchParams();
let [imagemain,setImageMain] = useState(null);
let [ttitle,setTtitle] = useState(null);
let [tdesc,setTdesc] = useState(<span>...</span>);
let [vermas,setVerMas] = useState(null);
let tdescx=<span>...</span>;
var userAgent = navigator.userAgent || navigator.vendor || window.opera;
/*
  if(/android/i.test(userAgent)){
        alert("Android....");
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        alert("iOS....");
    }
    if (/windows phone/i.test(userAgent)) {
        alert("Windows Phone");
    }
*/
const theparam = async() =>{
    let url = new URL(window.location.href);
    let arserv = new ArticleService();
    if(url.pathname.substring(1)!==''){
    let resp = await arserv.getArticulo({
      ses:'12345678zmcbvxnn',
      flg:2,
      idart:atob(url.pathname.substring(1))})
    .then((resp)=>{
      if(resp.err===0){
        setImageMain(resp.Imgx[0].imgx);
        setTtitle(resp.Valor.titulo);

        let splx = resp.Valor.contenido.split("</p>");
        setTdesc(splx[0]+' ...</p><p><strong>Si quieres ver el articulo completo, te invitamos a descargar la app de Comunidad PT.</strong></p>');
        setVerMas(resp.Valor.vermasurl);
      }
      //console.log("searc...."+atob(url.pathname.substring(1)));
    });
  }

//    console.log("searc...."+url.pathname.substring(1));
};


let ignore = false;
useEffect(()=>{
  if(ignore!==true){
    theparam();
    ignore=true;
  }
},[]);

  return(
    <>
    <div style={styles.tactionb} >
    {  /android/i.test(userAgent)===true ? (
        <a href="https://play.google.com/store/apps/details?id=com.link2loyalty.cpumping"><img src={require('../assets/img/playstore.png')} width="100" /></a>
      ):'.'
    }
    {
      /iPad|iPhone|iPod/.test(userAgent)==true && !window.MSStream ?(
        <a href="https://apps.apple.com/mx/app/comunidad-pt/id1598967541?l=es-GB"><img src={require('../assets/img/appstore.png')} width="100" /></a>
      ):'.'
    }
    </div>
    {
      imagemain!==null ? (
          <img src={imagemain} style={styles.imgmain} width="100" />
      ) : <img src={tlogo} style={styles.imgmain} width="100" />
    }

    <div style={styles.ttlebar}>
      {ttitle!==null ? (
        <h2>{ttitle}</h2>
      ):'Cargando...' }
    </div>
    {
      tdesc!==null ? (
      <div className="wrapdesc" style={styles.palign} dangerouslySetInnerHTML={{ __html: tdesc }} />
    ) : '...'
    }
    {
    /*  vermas!==null ? (
        <div style={{textAlign:'center',marginBottom:10,paddingTop:20,paddingBottom:20}}>
        <a style={styles.btnvermas} href={vermas}>Ir al link</a>
        </div>
      ) : ''*/
    }

    </>
  )
}

export default DetailArticle;
